import NaRender from '@baidu/onemap-design/dist/packages/na-render/na-render';
import adSpace from './adSpace.vue';
export default {
  components: {
    adSpace,
    NaRender
  },
  props: {
    adInfo: {
      // 获取的广告数据, sdk广告多包了一层adData
      type: Object,
      default: () => ({})
    },
    adAspectRatio: Number,
    // 广告图片宽高比
    adType: String,
    // 广告类型
    adCoreUtils: Object // new AdCore拿到的js sdk实例
  },

  data() {
    return {
      isAdClose: false
    };
  },
  computed: {
    isShowSdk() {
      if (this.adType === 'sdk') {
        const {
          imageUrl = '',
          title = ''
        } = this.adData || {};
        return !!(imageUrl && title) && !this.isAdClose;
      }
      return false;
    },
    adData() {
      var _this$adInfo;
      return ((_this$adInfo = this.adInfo) === null || _this$adInfo === void 0 ? void 0 : _this$adInfo.adData) || {};
    }
  },
  methods: {
    handleShowAd() {
      // 展示埋点上报
      if (!this.adCoreUtils) {
        return;
      }
      this.adCoreUtils.sendMonitorEvent(this.adInfo, {
        resource_id: 'push_page'
      }, 'show');
    },
    handleClickAd() {
      // 点击埋点上报
      if (!this.adCoreUtils) {
        return;
      }
      this.adCoreUtils.sendMonitorEvent(this.adInfo, {
        resource_id: 'push_page'
      }, 'click');
    },
    handleCloseAd() {
      this.isAdClose = true;
    }
  }
};